import React from "react";
import Nav from "react-bootstrap/Nav";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Popover from "react-bootstrap/Popover";
import config from "../../../config";
import {getActiveAuction} from "../../common/utils";

const FirstLookNav = ({user_profile, className}) => {
    const active_auction = getActiveAuction();
    const user_has_tier = user_profile && user_profile.tier.tier_key !== 'no_tier';
    const can_see_auction = active_auction && (active_auction.is_vip_auction === false || (active_auction.is_vip_auction === true && user_has_tier));

    let auction_tooltip = 'There are currently no items on auctions';
    if(active_auction && !can_see_auction){
        auction_tooltip = <span>The current Auction lot is exclusive to Rewards Members
            only - <a href={`${config.host_rebag}/rewards/`} className="description-btn-link">Learn More</a>
        </span>;
    }

    if (can_see_auction) {
        return (
            <Nav.Item
                as="a"
                href={`${config.auction_collection}${active_auction['tag']}`}
                className={className}
            >
                Auction
            </Nav.Item>
        )
    }
    return (
        <OverlayTrigger
            rootClose={true}
            placement={"bottom"}
            trigger={['click']}
            overlay={
                <Popover id="header-menu-nav__popover">
                    <Popover.Content>
                        {auction_tooltip}
                    </Popover.Content>
                </Popover>
            }
        >
            <Nav.Item
                className={`${className} grey-btn`}
                as="button"
            >
                Auction
            </Nav.Item>
        </OverlayTrigger>
    )
}

export default FirstLookNav;